import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/pages/auth/Login';
import ExerciseIndex from '@/pages/exercise/Index';
import IndexRecommend from '@/pages/exercise/IndexRecommend';
import ExerciseDetail from '@/pages/exercise/Detail';
import Top from '@/pages/top/Top';
import Form from '@/pages/form/Form';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Login',
            component: Top
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        }, {
            path: '/index',
            name: 'ExerciseIndex',
            component: ExerciseIndex
        }, {
            path: '/index/:recommend',
            name: 'ExerciseIndexRecommend',
            component: IndexRecommend
        }, {
            path: '/content/:id',
            name: 'ExerciseDetail',
            component: ExerciseDetail
        }, {
            path: '/top',
            name: 'Top',
            component: Top
        }, {
            path: '/form',
            name: 'Form',
            component: Form
        },
        {
            path: '/keeprehab',
            name: 'DirectoryTop',
            component: Top
        },
        {
            path: '/keeprehab/login',
            name: 'LoginSubDir',
            component: Login
        }, {
            path: '/keeprehab/index',
            name: 'ExerciseIndexSubDir',
            component: ExerciseIndex
        }, {
            path: '/keeprehab/index/:recommend',
            name: 'ExerciseIndexRecommendSubDir',
            component: IndexRecommend
        }, {
            path: '/keeprehab/content/:id',
            name: 'ExerciseDetailSubDir',
            component: ExerciseDetail
        }, {
            path: '/keeprehab/top',
            name: 'TopSubDir',
            component: Top
        }, {
            path: '/keeprehab/form',
            name: 'FormSubDir',
            component: Form
        }

    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js